import type { ActivityModule } from './activity';
import { getHighestLevel } from './score';
import { audioManager } from './audio';
import { mountBackground } from './background';

export function mountHub(root: HTMLElement, activities: ActivityModule[]): void {
  root.innerHTML = '';

  // Fundo animado (paisagem natural). Auto-limpa quando o canvas sai do DOM
  // — o router faz innerHTML='' ao trocar de rota, então o cleanup roda sozinho.
  mountBackground(root, {
    timeOfDay: 'morning',
    cloudSpeed: 1.0,
    sunSpeed: 1.0,
    particleCount: 18,
    lightIntensity: 0.75,
    detailLevel: 'medium',
    enableBirds: true,
  });

  const page = document.createElement('div');
  page.className = 'hub-page';
  page.innerHTML = `
    <header class="hub-header">
      <h1>Atividades</h1>
      <p class="hub-subtitle">Matemática e linguagem para crianças — escolha uma atividade para começar.</p>
      <button class="hub-mute" type="button" aria-label="Ligar/desligar som">${audioManager.isMuted() ? '🔇 Som off' : '🔊 Som on'}</button>
    </header>
    <main class="hub-grid" role="list"></main>
    <footer class="hub-footer">
      <p>Adaptado de <a href="https://gcompris.net/" target="_blank" rel="noopener">GCompris</a> (KDE) — GPL-3.0-or-later · <a href="creditos.html">Créditos, licenças e código-fonte</a></p>
    </footer>
  `;

  const grid = page.querySelector<HTMLElement>('.hub-grid')!;
  for (const activity of activities) {
    const progress = getHighestLevel(activity.id);
    const card = document.createElement('button');
    card.className = 'activity-card';
    card.type = 'button';
    card.setAttribute('role', 'listitem');
    card.innerHTML = `
      <img class="activity-card__icon" src="${activity.iconPath}" alt="" aria-hidden="true" />
      <h2 class="activity-card__title">${activity.title}</h2>
      <p class="activity-card__desc">${activity.description}</p>
      <div class="activity-card__meta">
        <span class="activity-card__age">${activity.ageMin}–${activity.ageMax} anos</span>
        <span class="activity-card__progress">Nível ${Math.min(progress + 1, activity.totalLevels)} / ${activity.totalLevels}</span>
      </div>
    `;
    card.addEventListener('click', () => {
      audioManager.play('click');
      window.location.hash = `/${activity.id}`;
    });
    grid.appendChild(card);
  }

  const muteBtn = page.querySelector<HTMLButtonElement>('.hub-mute')!;
  muteBtn.addEventListener('click', () => {
    audioManager.setMuted(!audioManager.isMuted());
    muteBtn.textContent = audioManager.isMuted() ? '🔇 Som off' : '🔊 Som on';
  });

  root.appendChild(page);
}
